'use client'

import { PageAppRouter } from "@/@types/page";
import { getCms } from "@/lib/cms";
import { cacheRevalidateDuration } from "../models/cache";
import Builder from "../builder";

export default async function View(
  props: PageAppRouter<{ locale: string }> & {
    error: Error & { digest?: string };
    reset: () => void;
  }
) {
  const { locale: lang } = (await props.params) ?? {};

  const [homepage, submission, footer] = await Promise.all([
    getCms("homepage", lang).then(([res]) => res),
    getCms("submissions", lang, {
      next: { revalidate: cacheRevalidateDuration() },
      pLevel: 2,
    }).then(([res]) => res[0]),
    getCms("footers", lang, {
      next: { revalidate: cacheRevalidateDuration() },
      pLevel: 3,
    }).then(([res]) => res[0]),
  ]);

  const menu =
    homepage?.content?.find((template) => template.__component === "shared.menu")
      ?.menus || [];

  const templates = [
    {
      __component: "shared.menu",
      id: 81,
      menus: menu,
    },
    {
      __component: "error-view",
      id: 84,
      error: props.error,
      onRefresh: props.reset,
    },
    {
      __component: "shared.submission",
      id: 82,
      submission: submission,
    },
    {
      __component: "shared.footer",
      id: 83,
      footer: footer,
    },
  ];

  return templates.map((template, idx) => (
    <Builder key={idx} template={template} />
  ));
}
